import { userInfoHeight } from "@components/user-info/user-info";
import { Typography, Grid2 } from "@mui/material";
import { neutral } from "@flat-ui";

/** Content to show when user does not belong to any group or project */
export function MemberProfileEmptyPage(): JSX.Element {
  return (
    <Grid2
      container
      direction="column"
      justifyContent="center"
      alignItems="center"
      sx={{
        height: userInfoHeight,
        backgroundColor: neutral[50],
        width: "100%",
      }}
    >
      <Grid2 sx={{ mb: "30px", px: "30px" }}>
        <Typography
          sx={{
            fontSize: "16px",
            fontWeight: "600",
            color: neutral[600],
          }}
        >
          Member is not connected to any projects or groups
        </Typography>
      </Grid2>
    </Grid2>
  );
}
